import {asset} from 'imba';
import url from './supper.jpg';
export default asset({
	url: url,
	type: 'image',
	width: 2127,
	height: 2126,
	toString: function(){ return this.url;}
})